import { ATTRIBUTES, CLASS_NAME } from '@/constants';

function insert(string, index, value) {
  if (!value) {
    // eslint-disable-next-line no-param-reassign
    value = '';
  }

  return string.substr(0, index) + value + string.substr(index);
}

function splice(str, index, count, add) {
  if (index < 0) {
    // eslint-disable-next-line no-param-reassign
    index = str.length + index;
    if (index < 0) {
      // eslint-disable-next-line no-param-reassign
      index = 0;
    }
  }

  return str.slice(0, index) + (add || '') + str.slice(index + count);
}

function collectingImagesFromContent(contentString) {
  if (contentString && contentString.length) {
    const imgReg = /<img.*?(?:>|\/>)/gi;

    return contentString.match(imgReg);
  }

  return null;
}

function collectingDataTitleFromImage(image) {
  // eslint-disable-next-line no-useless-escape
  const titleReg = /title=[\'\"]?([^\'\"]*)[\'\"]?/gi;
  const titles = image.match(titleReg);
  let result = null;

  if (titles && titles.length > 0) {
    // eslint-disable-next-line prefer-destructuring
    result = titles[0];
    result = result.replace('title="', '');
    result = result.replace('"', '');
  }

  return result;
}

function collectingDataAltFromImage(image) {
  // eslint-disable-next-line no-useless-escape
  const altReg = /alt=[\'\"]?([^\'\"]*)[\'\"]?/gi;
  const altcontent = image.match(altReg);
  let result = null;

  if (altcontent && altcontent.length > 0) {
    // eslint-disable-next-line prefer-destructuring
    result = altcontent[0];
    result = result.replace('alt="', '');
    result = result.replace('"', '');
  }

  return result;
}

function collectingDataHashFromImage(image) {
  // eslint-disable-next-line no-useless-escape
  const hashReg = /data-filename-hash=[\'\"]?([^\'\"]*)[\'\"]?/gi;
  const hashContent = image.match(hashReg);
  let result = null;

  if (hashContent && hashContent.length > 0) {
    // eslint-disable-next-line prefer-destructuring
    result = hashContent[0];
    result = result.replace('data-filename-hash="', '');
    result = result.replace('"', '');
  }

  return result;
}

function collectingDataClassFromImage(image) {
  // eslint-disable-next-line no-useless-escape
  const classReg = /class=[\'\"]?([^\'\"]*)[\'\"]?/gi;
  const classContent = image.match(classReg);
  let result = null;

  if (classContent && classContent.length > 0) {
    // eslint-disable-next-line prefer-destructuring
    result = classContent[0];
    result = result.replace('class="', '');
    result = result.replace('"', '');
  }

  return result;
}

function collectingDataSrcFromImage(image) {
  // eslint-disable-next-line no-useless-escape
  const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/gi;
  const srcs = image.match(srcReg);
  let src = null;

  if (srcs && srcs.length > 0) {
    // eslint-disable-next-line prefer-destructuring
    src = srcs[0];
    src = src.replace('src="', '');
    src = src.replace('"', '');
  }

  return src;
}

function changeContentImageSrc(contentString) {
  const images = collectingImagesFromContent(contentString);

  if (images && images.length > 0) {
    images.forEach((image) => {
      const title = collectingDataTitleFromImage(image);
      // eslint-disable-next-line no-useless-escape
      const altReg = /alt=[\'\"]?([^\'\"]*)[\'\"]?/gi;
      // eslint-disable-next-line no-useless-escape
      const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/gi;
      const altContent = collectingDataAltFromImage(image);
      const imageIndex = contentString.indexOf(image);
      const imageLength = image.length;
      const dataHash = collectingDataHashFromImage(image);
      const classContent = collectingDataClassFromImage(image);
      let index = -1;

      if (altContent) {
        // eslint-disable-next-line no-param-reassign
        image = image.replace(srcReg, '');
        // eslint-disable-next-line no-param-reassign
        image = image.replace('  ', ' ');
        // eslint-disable-next-line no-param-reassign
        image = image.replace(altReg, `alt="${title}"`);

        if (!dataHash) {
          index = image.indexOf('>');
          // eslint-disable-next-line no-param-reassign
          image = insert(image, index, ` ${ATTRIBUTES.DATA_FILENAME_HASH}="${altContent}"`);
        }

        if (!classContent) {
          index = image.indexOf('>');
          // eslint-disable-next-line no-param-reassign
          image = insert(image, index, ` class="${CLASS_NAME.IMAGE_CLASS_NAME}"`);
        }
      } else {
        // eslint-disable-next-line no-param-reassign
        image = '';
      }

      // eslint-disable-next-line no-param-reassign
      contentString = splice(contentString, imageIndex, imageLength, image);
    });
  }

  return contentString;
}

function replacerMarkDownTagToHTMLTag(inputString, regexString, replaceTag) {
  if (!inputString) return null;

  const regex = RegExp(`<${regexString}>`, 'gi');

  return inputString.replace(regex, (match) => {
    const emailAddress = match.substring(1, match.length - 1);
    return `<${replaceTag}>${emailAddress}</${replaceTag}>`;
  });
}

function replaceHTMLTagBackToMarkDownTag(inputString, regexString, htmlTag) {
  if (!inputString) return null;

  const regex = RegExp(`<${htmlTag}>${regexString}</${htmlTag}>`, 'gi');

  return inputString.replace(regex, (match) => {
    const contentString = match.substring(
      `<${htmlTag}>`.length,
      match.length - `</${htmlTag}>`.length
    );
    return `<${contentString}>`;
  });
}

export {
  insert,
  splice,
  collectingImagesFromContent,
  collectingDataTitleFromImage,
  collectingDataAltFromImage,
  collectingDataHashFromImage,
  collectingDataClassFromImage,
  collectingDataSrcFromImage,
  changeContentImageSrc,
  replacerMarkDownTagToHTMLTag,
  replaceHTMLTagBackToMarkDownTag
};
